import { render, staticRenderFns } from "./_CommentairesFichiers.vue?vue&type=template&id=3867a9be&scoped=true&"
import script from "./_CommentairesFichiers.vue?vue&type=script&lang=ts&"
export * from "./_CommentairesFichiers.vue?vue&type=script&lang=ts&"
import style0 from "./_CommentairesFichiers.vue?vue&type=style&index=0&id=3867a9be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3867a9be",
  null
  
)

export default component.exports